import React from 'react';
import '../styles/AblCEO.css';
import ceoImage from '../Assets/Images/abl.png'; // Replace with actual image path

const CeoMessage = () => {
  return (
    <section className="ceo-message-section">
      <div className="container">
        <p className="intro-text">
           AKIJ touches many people and many lives through various sectors and products. And now with its foray into bakery products (Breads and Buns, Cakes, Biscuits, Cookies, Wafers and more). Akij Bakers Ltd. was established by Akij Insaf Group in 2020. Since its beginning, Akij Bakers Ltd has been constantly trying to come up with new, healthy, delicious products considering the tastes of the people of this country.
        </p>

        <div className="ceo-box">
          <div className="ceo-image">
            <img src={ceoImage} alt="CEO" />
          </div>
          <div className="ceo-content">
            <h2>MESSAGE FROM ABL.</h2>
            <p>
                AKIJ touches many people and many lives through various sectors and products. And now with its foray into bakery products (Breads and Buns, Cakes, Biscuits, Cookies, Wafers and more). Akij Bakers Ltd. was established by Akij Insaf Group in 2020. Since its beginning, Akij Bakers Ltd has been constantly trying to come up with new, healthy, delicious products considering the tastes of the people of this country.
            </p>
            <p>Stay safe, stay blessed.</p>
            <div className="ceo-name">
              <strong>Aouther Name</strong><br />
              Designation<br />
              Akij Bakers Ltd.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CeoMessage;
